import React from 'react';
import i18n from 'util/i18n';
import { isPVQForm } from 'helpers/form';
import connectSubsection from 'components/Section/shared/SubsectionConnector';
import { HISTORY, HISTORY_FEDERAL } from 'config/formSections/history';
import ConnectedFederal from './Federal';

const sectionConfig = {
  key: HISTORY_FEDERAL.key,
  section: HISTORY.name,
  subsection: HISTORY_FEDERAL.name,
};

interface Props {
  inReview?: boolean
  formType?: string
}

const FederalWrapper: React.FC<Props> = function (props) {
  const { inReview, formType } = props;
  const isPVQ = isPVQForm(formType);
  return isPVQ ? (
    <div>
      <h1 className="section-header">{i18n.t('history.pvq.destination.federal')}</h1>
      {i18n.m('history.pvq.federal.info')}
      <ConnectedFederal required={inReview} />
    </div>
  ) : (
    <div>
      <h1 className="section-header">{i18n.t('history.destination.federal')}</h1>

      <ConnectedFederal required={inReview} />
    </div>
  );
};

FederalWrapper.defaultProps = {
  inReview: false,
  formType: '',
};

export default connectSubsection(FederalWrapper, sectionConfig);
